import React from "react";
import { Loader2 } from "lucide-react";

export default function AdminLoading({ message = "Chargement..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-slate-500">
      <Loader2 className="h-8 w-8 animate-spin text-[#3a00e0] mb-3" />
      <p className="text-sm">{message}</p>
    </div>
  );
}
